<template>
  <div class="bluetooth">
      <div class="content-list">
         <div class="list-title">
           {{langJson[lang].title1}}
         </div>
         <ul>
           <li>
             <div class="text">
               <span class="cir">1</span>
               <span>{{langJson[lang].text11}}</span>
             </div>
             <div class="img">
               <img :src="imgsrc1" alt="">
             </div>
           </li>
           <li>
             <div class="text">
               <span class="cir">2</span>
               <span>{{langJson[lang].text12}}</span>
               <div class="ash">
                 {{langJson[lang].text12sp}}
               </div>
             </div>
             <div class="img">
               <img :src="langJson[lang].iimgsrc2" alt="">
             </div>
           </li>
           <li>
             <div class="text">
               <span class="cir">3</span>
               <span>  {{langJson[lang].text13}}</span>
             </div>
           </li>
         </ul>

      </div>
      <div class="content-list">
         <div class="list-title">
           {{langJson[lang].title2}}
         </div>
         <ul>
           <li>
             <div class="text">
              
               <span>{{langJson[lang].text21}}</span>
             </div>
             <div class="img">
               <img :src="langJson[lang].iimgsrc3" alt="">
             </div>
           </li>
         
         </ul>

      </div>
      <div class="content-list">
         <div class="list-title">
           {{langJson[lang].title3}}
         </div>
         <ul>
           <li>
             <div class="text">
              <span class="bd">{{langJson[lang].text31}}</span>
               <span>{{langJson[lang].text32}}</span>
             </div>
             <div class="img">
               <img :src="langJson[lang].iimgsrc2" alt="">
             </div>
           </li>
         
         </ul>

      </div>
      <div class="content-list">
        <ul>
          <li>
            <div class="text">
              <span>{{langJson[lang].text41}}</span>
            </div>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>

import {adaptive} from "@/utils/util"
export default {
  name: "bluetooth",
  data() {
    return {
      lang:"en",
      langJson: {
        zh: {
          docTitle:"蓝牙问题",
          title1: "情况1:蓝牙连接断开",
          text11: "请检查手表和手机蓝牙开关是否均为开启状态。",
          text12:"iOS用户请在APP的蓝牙连接功能中检查是否能找到手表，若找不到：",
         text12sp:"需在iOS的设置中「忽略此设备」后再打开APP进行连接。",
          text13:"若仍无法连接，请在手表上开关蓝牙，或长按手表电源键重启手表后重试。",
          title2:"情况2:超级省电模式",
          text21:"请「长按电源键」查看手表是否处于「超级省电模式」，此模式下手表蓝牙将关闭。",
          title3:"情况3:与其他手机配对过",
          text31:"如果手表与您的另一个手机配对过，",
          text32:"请在另一个手机上取消配对和忽略手表。",
          text41:"若以上方法未能解决问题，请尝试重置手表「手表/Home键/设置/重置手表」。若仍未解决，请联系官方客服。",
          iimgsrc2:require("@/assets/images/bluetooth/pic_bt_cn.png"),
          iimgsrc3:require("@/assets/images/bluetooth/pic_spm_cn.png"),
 

        },
        tw: {
          docTitle:"藍牙問題",
          title1: "情況1:藍牙連接斷開",
          text11: "請檢查手錶和手機藍牙開關是否均為開啟狀態。",
          text12:`iOS用戶請在APP的藍牙連接功能中檢查是否能找到手錶，若找不到：`,
         text12sp:`需在iOS的設置中「忽略此設備」後再打開APP進行連接。`,
          text13:"若仍無法連接，請在手錶上開關藍牙，或長按手錶電源鍵重啟手錶後重試。",
          title2:"情況2:超級省電模式",
          text21:"請「長按電源鍵」查看手錶是否處於「超級省電模式」，此模式下手表藍牙將關閉。",
          title3:"情況3:與其他手機配對過",
          text31:`如果手錶與您的另一個手機配對過，`,
          text32:"請在另一個手機上取消配對並忽略手錶。",
          text41:`"若以上方法未能解決問題，請嘗試重置手錶「手錶/Home鍵/設置/重置手錶」。
若仍未解決，請聯繫官方客服。"`,

          iimgsrc2:require("@/assets/images/bluetooth/pic_bt_tw.png"),
          iimgsrc3:require("@/assets/images/bluetooth/pic_spm_tw.png"),
        },
        en: {
          docTitle:"Device not found?",
          title1: "Situation 1: Bluetooth disconnected",
          text11: "Please make sure the Bluetooth on your smartwatch and phone are turned on.",
          text12:`For iOS users, please check whether the watch can be found in the Bluetooth connection function of the APP, if not:`,
         text12sp:`"You need to ""forget this device"" in the iOS settings and then open the APP to connect."`,
          text13:"If you still can't connect, please turn off and on the Bluetooth on the watch, or press and hold the watch's power button to restart the watch and try again.",
          title2:"Situation 2: Super power saving mode",
          text21:"Please 「long press the power button」 to check whether the watch is in 「Super power saving mode」.In this mode, the watch's Bluetooth will be turned off.",
          title3:"Situation 3: The watch was paired with another phone",
          text31:`"If the watch has been paired with another phone, `,
          text32:`unpair it and ""forget the watch"" on the other phone."`,
          text41:`"If the above methods do not solve the problem, please try to reset the watch: Press Home button-click Settings-click Reset watch.
If it is still not resolved, please contact the official customer service. "`,

          iimgsrc2:require("@/assets/images/bluetooth/pic_bt_en.png"),
          iimgsrc3:require("@/assets/images/bluetooth/pic_spm_en.png"),
        },
        es: {
          docTitle:"¿Dispositivo no encontrado?",
          title1: "Situación 1: Bluetooth desconectado",
          text11: "Asegúrese de que el Bluetooth de su reloj inteligente y su teléfono estén encendidos.",
          text12:`Para usuarios de iOS, verifique si el reloj se puede encontrar en la función de conexión Bluetooth de la aplicación, si no:`,
         text12sp:`"Debe ""olvidar este dispositivo"" en la configuración de iOS y luego abrir la aplicación para conectarse."`,
          text13:"Si aún no puede conectarse, apague y encienda el Bluetooth en el reloj, o presione y mantenga presionado el botón de encendido del reloj para reiniciar el reloj e intente nuevamente.",
          title2:"Situación 2: modo de súper ahorro de energía",
          text21:"「Mantenga presionado el botón de encendido」 para verificar si el reloj está en 「Modo de súper ahorro de energía」. En este modo, el Bluetooth del reloj se apagará.",
          title3:"Situación 3: el reloj se emparejó con otro teléfono",
          text31:`"Si el reloj se ha vinculado con otro teléfono,`,
          text32:` desvincúlelo y ""olvídese del reloj"" en el otro teléfono."`,
          text41:`"Si los métodos anteriores no resuelven el problema, intente restablecer el reloj: presione el botón Inicio, haga clic en Configuración, haga clic en Restablecer reloj.
Si aún no se resuelve, comuníquese con el servicio al cliente oficial. "`,

          iimgsrc2:require("@/assets/images/bluetooth/pic_bt_es.png"),
          iimgsrc3:require("@/assets/images/bluetooth/pic_spm_es.png"),
        },
        jp: {
          docTitle:"デバイスが見つかりませんか？",
          title1: "状況1：Bluetoothが切断されている",
          text11: "スマートウォッチとスマートフォンのBluetoothが両方ともオンになっていることを確認してください。",
          text12:`iOSユーザーの場合、時計がAPPのBluetooth接続機能にあるかどうかを確認してください。見つからない場合は、次のようにします。`,
         text12sp:`iOSの設定で「このデバイスを忘れる」必要があります。次にAPPを開いて接続します。`,
          text13:"それでも接続できない場合は、時計のBluetoothをオフにしてからオンにするか、時計の電源ボタンを押し続けて時計を再起動し、もう一度お試しください。",
          title2:"状況2：超省電力モード",
          text21:"「電源ボタンを長押し」して、時計が「超省電力モード」になっているか確認してください。 このモードでは、時計のBluetoothがオフになります。",
          title3:"状況3：時計が別のスマートフォンとペアリングされた",
          text31:`時計が別の携帯電話とペアリングされている場合は、`,
          text32:`ペアリングを解除して、他の携帯電話で「時計を忘れる」。`,
          text41:`"上記の方法で問題が解決しない場合は、時計をリセットしてみてください。[ホーム]ボタンを押し、[設定]をクリックし、[時計をリセット]をクリックします。
それでも解決しない場合は、公式カスタマーサービスにご連絡ください。"`,

          iimgsrc2:require("@/assets/images/bluetooth/pic_bt_jp.png"),
          iimgsrc3:require("@/assets/images/bluetooth/pic_spm_jp.png"),
        },
      },
      
      imgsrc1:require("@/assets/images/bluetooth/pic_findbt.png")

    };
  },
  created(){
  var lang=this.$route.query.lang
   if(lang && this.langJson[lang]){
        this.lang =lang
   }else{
     lang = window.navigator.language;
    if (lang.includes("zh")) {
      if (lang.includes("HK") || lang.includes("TW")) {
        this.lang = "tw";
      } else {
        this.lang = "zh";
      }
    } else if (/^ja/.test(lang)) {
      this.lang = "jp";
    } else if (lang.includes("es")) {
      this.lang = "es";
    } else {
      this.lang = "en";
    }
     

   }
   document.title=this.langJson[this.lang].docTitle


  },
  mounted() {
      adaptive()   
  },
};
</script>

<style lang="less" scoped>
.bluetooth{
 width: 100%;
 background-color: #fff;
 overflow: hidden;
 padding-bottom: 5rem;
 .content-list{
   background-color: #FAFAFA;
   padding: 1rem 2rem;
   border-radius: 1.2rem;
  //  margin: 1rem;
  width: 90%;
  box-sizing: border-box;
  margin: 1rem auto 2rem;
   .list-title{
     font-size: 1.5rem;
     font-weight: 700;
     text-align: center;
     padding-top: 1rem;
   }
   ul{
     padding: 0;
     li{
       list-style: none;
       .text{
         color: #333;
           line-height: 1.5em;
           font-size: 1.4rem;
          //  font-weight: 700;
           .bd{
             font-weight: 700;
           }
           .ash{
             color: #666;
           }
           
         .cir{
           font-size: 1.4rem;
           color: #fff;
           height: 1.8rem;
           line-height: 1.8rem;
           display: inline-block;
           text-align: center;
           width: 1.8rem;
           border-radius: .9rem;
           background-color: #2E55F3;
           margin-right: .6rem;


       }

       }
       .img{
         text-align: center;
         padding: 1rem 0;
       }
       
     }
   }
 }

}
</style>>

